'use client'

import { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAward } from '@awesome.me/kit-94e593bf23/icons/classic/light'
import Tooltip from '@/app/_components/Tooltip'

import ProductFavoriteMarker from '@/app/_components/ProductFavoriteMarker'
import { decodeEntities } from '@/app/_lib/services/ClientUtil'
import Price from '@/app/_components/Price'
import '@/app/_styles/sale.css'

const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : ''

// className="border min-w-[150px] min-h-[150px] transition-all duration-500 scale-100 group-hover:scale-110 mx-auto"

const ProductListing = ({ product, hideDetails, className }) => {
    const [isBestSellerHovered, setIsBestSellerHovered] = useState(false)

    if ( ! (product.product_photo || product.thumb_1)) {
        return null
    }
    let imageSrc;
    
    if (product.file_name) {
        imageSrc  = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${product.file_name}`
    } else if (product.thumb_1) {
        imageSrc  = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/thumbs/${product.thumb_1}`
    } else {
        imageSrc  = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${product.product_photo}`
    }
    if ( ! product.url) {
        //product.url = '/'
        return null
    }
    
    return (
        <Link href={product.url} scroll={true} className={`product-listing relative group w-full ${className ? className : ''}`}>
            <div className="aspect-square bg-gray-3 p-3 flex flex-col relative">
                <div className="absolute z-40 bottom-3 left-3 flex items-center gap-4">
                    <ProductFavoriteMarker sub_product_id={product.sub_product_id} productName={decodeEntities(product.sub_product_name)} />
                    {product.is_best_seller === 1 && (
                        <Tooltip
                            content={`The ${capitalize(decodeEntities(product.sub_product_name))} is a best seller.`}
                            side="top"
                            onOpenChange={setIsBestSellerHovered}
                        >
                            <span className={`relative visible [@media(hover:hover)]:lg:invisible [@media(hover:hover)]:lg:group-hover:visible`}>
                                <FontAwesomeIcon
                                    icon={faAward}
                                    className={`${isBestSellerHovered ? 'text-primary' : 'text-light'} transition-colors text-xl`}
                                />
                            </span>
                        </Tooltip>
                    )}
                </div>
                <div className="overlay-block bg-white flex-1 flex items-center justify-center">
                    <Image
                        className="object-contain scale-75 sm:scale-85 lg:scale-100 lg:transition-all lg:duration-400 lg:group-hover:scale-105 "
                        src={imageSrc}
                        overrideSrc={imageSrc}
                        alt={decodeEntities(product.sub_product_name) || product.product_name || `${product.supplier_name || ''} ${product.designer_name || ''} product`.trim() || 'Product image'}
                        placeholder="blur"
                        blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII="
                        width={160}
                        height={160}
                        quality={90}
                        sizes="160px"
                    />
                </div>
            </div>
            <div className={`z-10 text-left min-h-16 mt-3 ${hideDetails ? 'hidden lg:block transition-opacity duration-400 opacity-0 lg:group-hover:opacity-100 lg:group-hover:bottom-3' : ''}`}>
                {product.on_sale == 1 && product.discount_percentage > 0 && (
                    <div className="text-2xs mb-3 text-red">
                        {/* Tier spend promotion, not a sale */}
                        {!product.is_tier_promo && <span className="font-semibold">Sale </span>}{product.discount_percentage}% off
                    </div>
                )}
                <div className="product-name capitalize font-medium text-sm mb-3">{ decodeEntities(product.sub_product_name) }</div>
                <div className="mb-3">
                    {(Number(product.lowest_price) > 0 && Number(product.highest_price) > 0 && Number(product.highest_price) > Number(product.lowest_price)) ? (
                        <div className="capitalize font-light text-sm">
                            <span className={product.original_lowest_price ? 'text-dark' : ''}>
                                <Price amount={product.lowest_price} /> - <Price amount={product.highest_price} />
                            </span>
                            {product.original_lowest_price && (
                                <div className="line-through text-light text-2xs">
                                    <Price amount={product.original_lowest_price} /> - <Price amount={product.original_highest_price} />
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="capitalize font-light text-sm">
                            <span className={product.original_price ? 'text-dark' : ''}>
                                <Price amount={product.retail_price} />
                            </span>
                            {product.original_price && (
                                <div className="line-through text-light text-2xs"><Price amount={product.original_price} /></div>
                            )}
                        </div>
                    )}
                    {product.shipping?.product_listing_message?.length > 0 &&
                        <div className="text-3xs text-light">
                            { product.shipping.product_listing_message }
                        </div>
                    }
                </div>
                <div className="flex flex-col xs:flex-row xs:items-center justify-start xs:space-x-2">
                    <div className={`capitalize text-3xs font-medium ${product.designer_name ? 'mb-1 xs:mb-0 xs:border-r-1 xs:pr-2' : ''}`}>{ product.supplier_name }</div>
                    <div className="capitalize text-3xs text-light">{ product.designer_name }</div>
                </div>
            </div>
            
        </Link>
    )
}

export default ProductListing
